import axios from '@/lib/AxApi';

export default
{
    selectRow(params, cb)
    {
        axios.get('/rest/DentalSolutionsTypes/selectRow',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
}


// WEBPACK FOOTER //
// ./src/api/dentalsolutiontypes.js